/* eslint-disable */
// AUTO-GENERATED by scripts/generate-operations.ts from @up2rent/models. Do not edit by hand.

export const accountPaymentRun = /* GraphQL */ `query AccountPaymentRun($accountId: ID!, $scope: ScopeInput) {
  accountPaymentRun(accountId: $accountId, scope: $scope) {
    accountId
    available
    channel
    endBalance
    fees
    heldCount
    heldTotal
    isThirdParty
    keepMin
    manualPriority
    obligations
    ownerContactIds
    paidNow
    payoutReduced
    payoutTotal
    reconciliationCovered
    releasable
    reserved
    rows {
      amount
      confirmationOverdue
      counterpartContactId
      counterpartName
      dueDate
      feeArrearsId
      held
      id
      kind
      orderStatus
      orderType
      ownerContactId
      pay
      paymentBatchId
      paymentOrderId
      priority
      recurringFundId
      recurringPaymentTemplateId
      recurringPendingRank
      recurringPeriodFrom
      reference
      status
      tier
      __typename
    }
    shortfall
    total
    verdict
    __typename
  }
}
`;

export const acpFundPositions = /* GraphQL */ `query AcpFundPositions($contactId: ID!) {
  acpFundPositions(contactId: $contactId) {
    accountLabelId
    balance
    class
    __typename
  }
}
`;

export const authMemberLookup = /* GraphQL */ `query AuthMemberLookup($input: AuthMemberLookupInput!) {
  authMemberLookup(input: $input) {
    betterAuthUserId
    clientId
    clientPendingDeletion
    contactId
    dynamoUserId
    language
    role
    rootUser
    status
    userPendingDeletion
    userRights
    userRoleId
    __typename
  }
}
`;

export const authUserByEmail = /* GraphQL */ `query AuthUserByEmail($input: AuthUserByEmailInput!) {
  authUserByEmail(input: $input) {
    betterAuthUserId
    clientId
    contactId
    dynamoUserId
    email
    emailVerified
    language
    __typename
  }
}
`;

export const authUserIdentity = /* GraphQL */ `query AuthUserIdentity($input: AuthUserIdentityInput!) {
  authUserIdentity(input: $input) {
    betterAuthUserId
    clientId
    contactId
    dynamoUserId
    email
    emailVerified
    language
    __typename
  }
}
`;

export const authUserPreferences = /* GraphQL */ `query AuthUserPreferences {
  authUserPreferences {
    name
    value
    __typename
  }
}
`;

export const feeArrears = /* GraphQL */ `query FeeArrears($scope: ScopeInput!) {
  feeArrears(scope: $scope) {
    alertCount
    alertDays
    count
    items {
      amount
      bankAccountId
      id
      inAlert
      openedAt
      originalAmount
      originPaymentOrderId
      ownerContactId
      servedBy {
        amount
        paymentOrderId
        servedAt
        __typename
      }
      servedCount
      __typename
    }
    totalAmount
    __typename
  }
}
`;

export const getAccountLabel = /* GraphQL */ `query GetAccountLabel($id: ID!) {
  getAccountLabel(id: $id) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAddress = /* GraphQL */ `query GetAddress($id: ID!) {
  getAddress(id: $id) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAdminCommunication = /* GraphQL */ `query GetAdminCommunication($id: ID!) {
  getAdminCommunication(id: $id) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAdminFile = /* GraphQL */ `query GetAdminFile($id: ID!) {
  getAdminFile(id: $id) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAdvertisement = /* GraphQL */ `query GetAdvertisement($id: ID!) {
  getAdvertisement(id: $id) {
    id
    type
    subType
    amenities
    amountOfFacades
    availabilityDate
    certificateOfConformity
    citationForPlanningOffence
    descriptions {
      language
      description
      __typename
    }
    delimitedZone
    floodProneArea
    furnished
    firstOccupancy
    gardenSurface
    heatingAmenities
    heatingType
    landTerrain
    landArea
    length
    nearbyComodities {
      type
      name
      distance
      __typename
    }
    publishedPlatforms {
      name
      publishedDate
      id
      __typename
    }
    planningPermission
    publishCadastralIncome
    resort
    rightOfPreemption
    subdivisionAuthorization
    wheelChairAccessible
    width
    terraceSurface
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAgencyRate = /* GraphQL */ `query GetAgencyRate($id: ID!) {
  getAgencyRate(id: $id) {
    id
    amountDetails {
      amountType
      endAmount
      feeApplied
      startAmount
      __typename
    }
    rateWhenVacant {
      amount
      type
      __typename
    }
    amountMinimumFees
    custom
    feesAppliedTo
    includedInAmount
    name
    owners {
      items {
        id
        agencyRateId
        contactId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    repartitionType
    type
    unitType
    vatRateId
    unitIds
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAgencyRateOwner = /* GraphQL */ `query GetAgencyRateOwner($id: ID!) {
  getAgencyRateOwner(id: $id) {
    id
    agencyRateId
    contactId
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getAgencyRateStatement = /* GraphQL */ `query GetAgencyRateStatement($id: ID!) {
  getAgencyRateStatement(id: $id) {
    id
    agencyRate {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    unitAmounts {
      unitId
      amountRateable
      fixedAmount
      __typename
    }
    totalAmountRateable
    totalFixedAmount
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getApplicationInvoice = /* GraphQL */ `query GetApplicationInvoice($id: ID!) {
  getApplicationInvoice(id: $id) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getApplicationInvoiceLine = /* GraphQL */ `query GetApplicationInvoiceLine($id: ID!) {
  getApplicationInvoiceLine(id: $id) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getApplicationPlan = /* GraphQL */ `query GetApplicationPlan($id: ID!) {
  getApplicationPlan(id: $id) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getApplicationSubscription = /* GraphQL */ `query GetApplicationSubscription($id: ID!) {
  getApplicationSubscription(id: $id) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getApplicationSubscriptionVariousOperation = /* GraphQL */ `query GetApplicationSubscriptionVariousOperation($id: ID!) {
  getApplicationSubscriptionVariousOperation(id: $id) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getApplicationVariousOperation = /* GraphQL */ `query GetApplicationVariousOperation($id: ID!) {
  getApplicationVariousOperation(id: $id) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getBankAccount = /* GraphQL */ `query GetBankAccount($id: ID!) {
  getBankAccount(id: $id) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getBillingItem = /* GraphQL */ `query GetBillingItem($id: ID!) {
  getBillingItem(id: $id) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getBuilding = /* GraphQL */ `query GetBuilding($id: ID!) {
  getBuilding(id: $id) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getBuildingEvent = /* GraphQL */ `query GetBuildingEvent($id: ID!) {
  getBuildingEvent(id: $id) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getBuildingOwner = /* GraphQL */ `query GetBuildingOwner($id: ID!) {
  getBuildingOwner(id: $id) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getBuildingSite = /* GraphQL */ `query GetBuildingSite($id: ID!) {
  getBuildingSite(id: $id) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCashExpectation = /* GraphQL */ `query GetCashExpectation($id: ID!) {
  getCashExpectation(id: $id) {
    id
    sourceType
    sourceId
    direction
    flowType
    status
    accountIds
    originalAmount
    openAmount
    disputedAmount
    expectedAmount
    issueDate
    dueDate
    confirmationDeadline
    structuredCommunication
    invoiceNumber
    reference
    counterpartyIban
    leaseId
    unitId
    ownerId
    contractorId
    isOffLedgerReceivable
    awaitingPosting
    lines {
      postingId
      accountClass
      originalAmount
      openAmount
      disputed
      periodFrom
      periodTo
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCause = /* GraphQL */ `query GetCause($id: ID!) {
  getCause(id: $id) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCharge = /* GraphQL */ `query GetCharge($id: ID!) {
  getCharge(id: $id) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getChargeEnvelope = /* GraphQL */ `query GetChargeEnvelope($id: ID!) {
  getChargeEnvelope(id: $id) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getChargeSection = /* GraphQL */ `query GetChargeSection($id: ID!) {
  getChargeSection(id: $id) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getChargeStatement = /* GraphQL */ `query GetChargeStatement($id: ID!) {
  getChargeStatement(id: $id) {
    id
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getClientContact = /* GraphQL */ `query GetClientContact($clientId: ID) {
  getClientContact(clientId: $clientId) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCommunication = /* GraphQL */ `query GetCommunication($id: ID!) {
  getCommunication(id: $id) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCommunicationSettingsProfile = /* GraphQL */ `query GetCommunicationSettingsProfile($id: ID!) {
  getCommunicationSettingsProfile(id: $id) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCompanyUser = /* GraphQL */ `query GetCompanyUser($id: ID!) {
  getCompanyUser(id: $id) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getContact = /* GraphQL */ `query GetContact($id: ID!) {
  getContact(id: $id) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCounterpartyIdentity = /* GraphQL */ `query GetCounterpartyIdentity($id: ID!) {
  getCounterpartyIdentity(id: $id) {
    id
    keyType
    key
    isFullRemittance
    kind
    contactId
    source
    status
    evidenceCount
    firstSeenAt
    lastSeenAt
    lastCounterpartName
    lastDecisionId
    evidenceTransactionIds
    exclusionReason
    exclusionComment
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCounterpartyRole = /* GraphQL */ `query GetCounterpartyRole($id: ID!) {
  getCounterpartyRole(id: $id) {
    id
    subjectId
    targetType
    targetId
    source
    status
    evidenceCount
    lastSeenAt
    lastDecisionId
    evidenceTransactionIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCreditCost = /* GraphQL */ `query GetCreditCost($id: ID!) {
  getCreditCost(id: $id) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCreditUsageCost = /* GraphQL */ `query GetCreditUsageCost($id: ID!) {
  getCreditUsageCost(id: $id) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCustomField = /* GraphQL */ `query GetCustomField($id: ID!) {
  getCustomField(id: $id) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getCustomSubscription = /* GraphQL */ `query GetCustomSubscription($id: ID!) {
  getCustomSubscription(id: $id) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getDocumentCategory = /* GraphQL */ `query GetDocumentCategory($id: ID!) {
  getDocumentCategory(id: $id) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getDocumentExtraction = /* GraphQL */ `query GetDocumentExtraction($id: ID!) {
  getDocumentExtraction(id: $id) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getDocumentNumber = /* GraphQL */ `query GetDocumentNumber($id: ID!) {
  getDocumentNumber(id: $id) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getEntityAlias = /* GraphQL */ `query GetEntityAlias($id: ID!) {
  getEntityAlias(id: $id) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getEntityRelation = /* GraphQL */ `query GetEntityRelation($id: ID!) {
  getEntityRelation(id: $id) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getFeeArrears = /* GraphQL */ `query GetFeeArrears($id: ID!) {
  getFeeArrears(id: $id) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getFile = /* GraphQL */ `query GetFile($id: ID!) {
  getFile(id: $id) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getFilterGroup = /* GraphQL */ `query GetFilterGroup($id: ID!) {
  getFilterGroup(id: $id) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getImportRun = /* GraphQL */ `query GetImportRun($id: ID!) {
  getImportRun(id: $id) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getIntegration = /* GraphQL */ `query GetIntegration($id: ID!) {
  getIntegration(id: $id) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getInternalComment = /* GraphQL */ `query GetInternalComment($id: ID!) {
  getInternalComment(id: $id) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getInvoice = /* GraphQL */ `query GetInvoice($id: ID!) {
  getInvoice(id: $id) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getInvoiceSetting = /* GraphQL */ `query GetInvoiceSetting($id: ID!) {
  getInvoiceSetting(id: $id) {
    id
    creditNoteFormat
    creditNoteLastUpdate
    creditNoteIncrementNumber
    invoiceFormat
    invoiceLastUpdate
    invoiceIncrementNumber
    paymentRequestFormat
    paymentRequestLastUpdate
    paymentRequestIncrementNumber
    receiptFormat
    receiptLastUpdate
    receiptIncrementNumber
    variousOperationFormat
    variousOperationLastUpdate
    variousOperationIncrementNumber
    customInvoicingConfiguration
    defaultVatRateId
    fiscalYearStart
    allPurposeInvoiceIssuer
    paymentBankAccountId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLearningEvent = /* GraphQL */ `query GetLearningEvent($id: ID!) {
  getLearningEvent(id: $id) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLease = /* GraphQL */ `query GetLease($id: ID!) {
  getLease(id: $id) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLeaseActionHistory = /* GraphQL */ `query GetLeaseActionHistory($id: ID!) {
  getLeaseActionHistory(id: $id) {
    id
    action
    comment
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    historyDetails {
      unitId
      newEndDate
      newSignatureDate
      newStartDate
      previousEndDate
      previousSignatureDate
      previousStartDate
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    communicationChannel
    communicationSendDate
    communicationByPlatform
    endReason
    endReasonOwnUseRelation
    endReasonOwnUseName
    initiator
    totalAmount
    totalAmountLabel
    automatic
    hasLeaseTypeChanged
    jiraId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLeaseAdditionalClause = /* GraphQL */ `query GetLeaseAdditionalClause($id: ID!) {
  getLeaseAdditionalClause(id: $id) {
    id
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    title
    body
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLeaseContact = /* GraphQL */ `query GetLeaseContact($id: ID!) {
  getLeaseContact(id: $id) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLeasePriceHistory = /* GraphQL */ `query GetLeasePriceHistory($id: ID!) {
  getLeasePriceHistory(id: $id) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getLeaseVariousOperation = /* GraphQL */ `query GetLeaseVariousOperation($id: ID!) {
  getLeaseVariousOperation(id: $id) {
    id
    accountLabelIds
    amount
    billingMode
    contactId
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dueDateDaysAfterPeriodStart
    endDate
    indexationBaseAmount
    indexationBaseIndexDate
    indexationFrozen
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issueLeadDays
    label
    lastInvoiceDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    operationType
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    periodNature
    reason
    separateInvoice
    startDate
    type
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getMortgage = /* GraphQL */ `query GetMortgage($id: ID!) {
  getMortgage(id: $id) {
    id
    lender
    durationInYears
    rateType
    interestRate
    aprRate
    startDate
    amount
    monthlyPayment
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getPaymentBatch = /* GraphQL */ `query GetPaymentBatch($id: ID!) {
  getPaymentBatch(id: $id) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getPaymentOrder = /* GraphQL */ `query GetPaymentOrder($id: ID!) {
  getPaymentOrder(id: $id) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getPosting = /* GraphQL */ `query GetPosting($id: ID!) {
  getPosting(id: $id) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getReconciliationDecision = /* GraphQL */ `query GetReconciliationDecision($id: ID!) {
  getReconciliationDecision(id: $id) {
    id
    decisionId
    transactionId
    relatedTransactionIds
    kind
    status
    source
    trigger
    actorId
    outcome
    score
    reasonCodes
    flowType
    amount
    links {
      amount
      linkId
      linkType
      __typename
    }
    allocations {
      invoiceId
      postingId
      amount
      awaitingPosting
      __typename
    }
    exclusionReason
    comment
    snoozedUntil
    reversesDecisionId
    appliesDecisionId
    decidedAt
    backfilled
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getReconciliationSetting = /* GraphQL */ `query GetReconciliationSetting($id: ID!) {
  getReconciliationSetting(id: $id) {
    id
    type
    allocationMode
    leaseId
    ownerId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getRecurringPaymentTemplate = /* GraphQL */ `query GetRecurringPaymentTemplate($id: ID!) {
  getRecurringPaymentTemplate(id: $id) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getReleaseNote = /* GraphQL */ `query GetReleaseNote($id: ID!) {
  getReleaseNote(id: $id) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getRepartitionKey = /* GraphQL */ `query GetRepartitionKey($id: ID!) {
  getRepartitionKey(id: $id) {
    id
    name
    type
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitRepartition {
      unitId
      value
      __typename
    }
    ownerRepartition
    tenantRepartition
    repartitionMetric
    technics
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getRepaymentStatement = /* GraphQL */ `query GetRepaymentStatement($id: ID!) {
  getRepaymentStatement(id: $id) {
    id
    accountOwnership
    delaysCleared
    expectedRent
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    rentsCollected
    repaymentStatementDetails {
      class
      customLabel
      invoiceId
      invoicePostingId
      originalTotalAmount
      periodFrom
      periodTo
      totalAmount
      transactionId
      type
      __typename
    }
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    totalReceivedInJointAccount
    totalExpectedInOwnerAccount
    unpaidRents
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getScheduleRule = /* GraphQL */ `query GetScheduleRule($id: ID!) {
  getScheduleRule(id: $id) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getSenderRule = /* GraphQL */ `query GetSenderRule($id: ID!) {
  getSenderRule(id: $id) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getSendingEmails = /* GraphQL */ `query GetSendingEmails($clientId: ID) {
  getSendingEmails(clientId: $clientId) {
    chargeEmail
    issueEmail
    chargeEmailFromSendingSource
    issueEmailFromSendingSource
    __typename
  }
}
`;

export const getSendingSource = /* GraphQL */ `query GetSendingSource($id: ID!) {
  getSendingSource(id: $id) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getSetting = /* GraphQL */ `query GetSetting($id: ID!) {
  getSetting(id: $id) {
    id
    name
    value
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getSignatureDocument = /* GraphQL */ `query GetSignatureDocument($id: ID!) {
  getSignatureDocument(id: $id) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getStatement = /* GraphQL */ `query GetStatement($id: ID!) {
  getStatement(id: $id) {
    id
    amounts {
      name
      value
      __typename
    }
    attachSupportingDocuments
    chargeStatements {
      items {
        id
        chargeId
        statementId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    closingStatement
    periodFrom
    periodTo
    selectedPocketKeys
    source
    status
    sentDate
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    agencyRateStatements {
      items {
        id
        agencyRateId
        statementId
        totalAmountRateable
        totalFixedAmount
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    repaymentStatements {
      items {
        id
        accountOwnership
        delaysCleared
        expectedRent
        leaseId
        rentsCollected
        statementId
        totalReceivedInJointAccount
        totalExpectedInOwnerAccount
        unpaidRents
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    types
    viewType
    unitIds
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getStatementSetting = /* GraphQL */ `query GetStatementSetting($id: ID!) {
  getStatementSetting(id: $id) {
    id
    type
    custom
    disabled
    monthFrequency
    startMonth
    generationDay
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getSubscriptionUsageHistory = /* GraphQL */ `query GetSubscriptionUsageHistory($id: ID!) {
  getSubscriptionUsageHistory(id: $id) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTag = /* GraphQL */ `query GetTag($id: ID!) {
  getTag(id: $id) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTechnic = /* GraphQL */ `query GetTechnic($id: ID!) {
  getTechnic(id: $id) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTechnicLibrary = /* GraphQL */ `query GetTechnicLibrary($id: ID!) {
  getTechnicLibrary(id: $id) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTemplate = /* GraphQL */ `query GetTemplate($id: ID!) {
  getTemplate(id: $id) {
    id
    language
    name
    subject
    subjectRawFormat
    body
    bodyRawFormat
    type
    subType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTicket = /* GraphQL */ `query GetTicket($id: ID!) {
  getTicket(id: $id) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTransaction = /* GraphQL */ `query GetTransaction($id: ID!) {
  getTransaction(id: $id) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getTransactionRule = /* GraphQL */ `query GetTransactionRule($id: ID!) {
  getTransactionRule(id: $id) {
    id
    isFullRemittance
    remittanceInformation
    counterpartName
    counterpartAccountNumber
    usedFields
    exclude
    exclusionReason
    exclusionComment
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getUnit = /* GraphQL */ `query GetUnit($id: ID!) {
  getUnit(id: $id) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getUnitEvent = /* GraphQL */ `query GetUnitEvent($id: ID!) {
  getUnitEvent(id: $id) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getUnitInventory = /* GraphQL */ `query GetUnitInventory($id: ID!) {
  getUnitInventory(id: $id) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getUnitLease = /* GraphQL */ `query GetUnitLease($id: ID!) {
  getUnitLease(id: $id) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getUnitOwner = /* GraphQL */ `query GetUnitOwner($id: ID!) {
  getUnitOwner(id: $id) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getValuation = /* GraphQL */ `query GetValuation($id: ID!) {
  getValuation(id: $id) {
    id
    sourceType
    valorization
    date
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getVariousOperation = /* GraphQL */ `query GetVariousOperation($id: ID!) {
  getVariousOperation(id: $id) {
    id
    amount
    labels {
      language
      label
      __typename
    }
    numberOfMonths
    operationType
    paymentFrequency
    type
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const getVatRate = /* GraphQL */ `query GetVatRate($id: ID!) {
  getVatRate(id: $id) {
    id
    country
    label
    value
    vatKind
    customValues {
      name
      value
      __typename
    }
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const heldPayments = /* GraphQL */ `query HeldPayments($scope: ScopeInput!) {
  heldPayments(scope: $scope) {
    accountCount
    accounts {
      accountId
      available
      channel
      endBalance
      fees
      heldCount
      heldTotal
      isThirdParty
      keepMin
      manualPriority
      obligations
      ownerContactIds
      paidNow
      payoutReduced
      payoutTotal
      reconciliationCovered
      releasable
      reserved
      rows {
        amount
        confirmationOverdue
        counterpartContactId
        counterpartName
        dueDate
        feeArrearsId
        held
        id
        kind
        orderStatus
        orderType
        ownerContactId
        pay
        paymentBatchId
        paymentOrderId
        priority
        recurringFundId
        recurringPaymentTemplateId
        recurringPendingRank
        recurringPeriodFrom
        reference
        status
        tier
        __typename
      }
      shortfall
      total
      verdict
      __typename
    }
    heldCount
    heldTotal
    __typename
  }
}
`;

export const ibanSafeWorkspaceCounts = /* GraphQL */ `query IbanSafeWorkspaceCounts($numbers: [String!]!) {
  ibanSafeWorkspaceCounts(numbers: $numbers) {
    number
    safeWorkspaceCount
    __typename
  }
}
`;

export const importRunReceipt = /* GraphQL */ `query ImportRunReceipt($documentsOfCause: ChargeCauseKey, $importRunId: ID!) {
  importRunReceipt(documentsOfCause: $documentsOfCause, importRunId: $importRunId) {
    causes {
      blockedByCheckpoint {
        allocate
        pay
        read
        resolve
        sort
        tenant
        __typename
      }
      distinctValues {
        display
        maskedIban
        sectionIds
        totalAmount
        value
        vatNumber
        __typename
      }
      documentCount
      id
      key
      valueCount
      __typename
    }
    channel
    files
    finishedAt
    handled
    importRunId
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    __typename
  }
}
`;

export const importRunSetAsideFiles = /* GraphQL */ `query ImportRunSetAsideFiles($importRunId: ID!) {
  importRunSetAsideFiles(importRunId: $importRunId) {
    file {
      envelopeId
      fileId
      fileName
      __typename
    }
    original {
      envelopeId
      fileId
      fileName
      __typename
    }
    __typename
  }
}
`;

export const listAccountLabels = /* GraphQL */ `query ListAccountLabels($filter: ModelAccountLabelFilterInput, $limit: Int, $nextToken: String) {
  listAccountLabels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAddresses = /* GraphQL */ `query ListAddresses($filter: ModelAddressFilterInput, $limit: Int, $nextToken: String) {
  listAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAdminCommunications = /* GraphQL */ `query ListAdminCommunications($filter: ModelAdminCommunicationFilterInput, $limit: Int, $nextToken: String) {
  listAdminCommunications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      body
      clientId
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAdminFiles = /* GraphQL */ `query ListAdminFiles($filter: ModelAdminFileFilterInput, $limit: Int, $nextToken: String) {
  listAdminFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      bucket
      foreignKey
      foreignTableName
      key
      mimeType
      region
      size
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAdvertisements = /* GraphQL */ `query ListAdvertisements($filter: ModelAdvertisementFilterInput, $limit: Int, $nextToken: String) {
  listAdvertisements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      subType
      amenities
      amountOfFacades
      availabilityDate
      certificateOfConformity
      citationForPlanningOffence
      descriptions {
        language
        description
        __typename
      }
      delimitedZone
      floodProneArea
      furnished
      firstOccupancy
      gardenSurface
      heatingAmenities
      heatingType
      landTerrain
      landArea
      length
      nearbyComodities {
        type
        name
        distance
        __typename
      }
      publishedPlatforms {
        name
        publishedDate
        id
        __typename
      }
      planningPermission
      publishCadastralIncome
      resort
      rightOfPreemption
      subdivisionAuthorization
      wheelChairAccessible
      width
      terraceSurface
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAgencyRateOwners = /* GraphQL */ `query ListAgencyRateOwners($filter: ModelAgencyRateOwnerFilterInput, $limit: Int, $nextToken: String) {
  listAgencyRateOwners(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      agencyRateId
      contactId
      agencyRate {
        id
        amountMinimumFees
        custom
        feesAppliedTo
        includedInAmount
        name
        repartitionType
        type
        unitType
        vatRateId
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAgencyRates = /* GraphQL */ `query ListAgencyRates($filter: ModelAgencyRateFilterInput, $limit: Int, $nextToken: String) {
  listAgencyRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAgencyRateStatements = /* GraphQL */ `query ListAgencyRateStatements($filter: ModelAgencyRateStatementFilterInput, $limit: Int, $nextToken: String) {
  listAgencyRateStatements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      agencyRate {
        id
        amountMinimumFees
        custom
        feesAppliedTo
        includedInAmount
        name
        repartitionType
        type
        unitType
        vatRateId
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      unitAmounts {
        unitId
        amountRateable
        fixedAmount
        __typename
      }
      totalAmountRateable
      totalFixedAmount
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAllReleaseNotes = /* GraphQL */ `query ListAllReleaseNotes($status: ReleaseNoteStatus) {
  listAllReleaseNotes(status: $status) {
    id
    status
    publishedAt
    visibleToOwners
    contents {
      language
      title
      body
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const listApplicationInvoiceLines = /* GraphQL */ `query ListApplicationInvoiceLines($filter: ModelApplicationInvoiceLineFilterInput, $limit: Int, $nextToken: String) {
  listApplicationInvoiceLines(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listApplicationInvoices = /* GraphQL */ `query ListApplicationInvoices($filter: ModelApplicationInvoiceFilterInput, $limit: Int, $nextToken: String) {
  listApplicationInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listApplicationPlans = /* GraphQL */ `query ListApplicationPlans($filter: ModelApplicationPlanFilterInput, $limit: Int, $nextToken: String) {
  listApplicationPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listApplicationSubscriptions = /* GraphQL */ `query ListApplicationSubscriptions($filter: ModelApplicationSubscriptionFilterInput, $limit: Int, $nextToken: String) {
  listApplicationSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listApplicationSubscriptionVariousOperations = /* GraphQL */ `query ListApplicationSubscriptionVariousOperations($filter: ModelApplicationSubscriptionVariousOperationFilterInput, $limit: Int, $nextToken: String) {
  listApplicationSubscriptionVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listApplicationVariousOperations = /* GraphQL */ `query ListApplicationVariousOperations($filter: ModelApplicationVariousOperationFilterInput, $limit: Int, $nextToken: String) {
  listApplicationVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amount
      applicationPlanIncludedVariousOperationsId
      customerVisible
      duration
      labels {
        language
        label
        __typename
      }
      numberOfCredits
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listAuthUsers = /* GraphQL */ `query ListAuthUsers {
  listAuthUsers {
    betterAuthUserId
    contactPhoneNumber
    email
    firstName
    lastName
    memberships {
      clientId
      contactId
      organizationName
      role
      rootUser
      status
      __typename
    }
    name
    phoneNumber
    phoneNumberVerified
    __typename
  }
}
`;

export const listBankAccounts = /* GraphQL */ `query ListBankAccounts($filter: ModelBankAccountFilterInput, $limit: Int, $nextToken: String) {
  listBankAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listBillingItems = /* GraphQL */ `query ListBillingItems($filter: ModelBillingItemFilterInput, $limit: Int, $nextToken: String) {
  listBillingItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      baseAmount
      billingType
      amountCalculationType
      percentageBase
      period
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      quantity
      percentage
      allocationOption
      multipleUnitsSplit
      leaseIds
      unitIds
      buildingIds
      accountLabelId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listBuildingEvents = /* GraphQL */ `query ListBuildingEvents($filter: ModelBuildingEventFilterInput, $limit: Int, $nextToken: String) {
  listBuildingEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      buildingId
      type
      startDate
      endDate
      totalCost
      note
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listBuildingOwners = /* GraphQL */ `query ListBuildingOwners($filter: ModelBuildingOwnerFilterInput, $limit: Int, $nextToken: String) {
  listBuildingOwners(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      disabled
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      periodTo
      stake
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listBuildings = /* GraphQL */ `query ListBuildings($filter: ModelBuildingFilterInput, $limit: Int, $nextToken: String) {
  listBuildings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listBuildingSites = /* GraphQL */ `query ListBuildingSites($filter: ModelBuildingSiteFilterInput, $limit: Int, $nextToken: String) {
  listBuildingSites(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCashExpectations = /* GraphQL */ `query ListCashExpectations($filter: ModelCashExpectationFilterInput, $limit: Int, $nextToken: String) {
  listCashExpectations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      sourceType
      sourceId
      direction
      flowType
      status
      accountIds
      originalAmount
      openAmount
      disputedAmount
      expectedAmount
      issueDate
      dueDate
      confirmationDeadline
      structuredCommunication
      invoiceNumber
      reference
      counterpartyIban
      leaseId
      unitId
      ownerId
      contractorId
      isOffLedgerReceivable
      awaitingPosting
      lines {
        postingId
        accountClass
        originalAmount
        openAmount
        disputed
        periodFrom
        periodTo
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCauses = /* GraphQL */ `query ListCauses($filter: ModelCauseFilterInput, $limit: Int, $nextToken: String) {
  listCauses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      distinctValues {
        display
        sectionIds
        value
        __typename
      }
      importRunId
      key
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listChargeEnvelopes = /* GraphQL */ `query ListChargeEnvelopes($filter: ModelChargeEnvelopeFilterInput, $limit: Int, $nextToken: String) {
  listChargeEnvelopes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCharges = /* GraphQL */ `query ListCharges($filter: ModelChargeFilterInput, $limit: Int, $nextToken: String) {
  listCharges(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listChargeSections = /* GraphQL */ `query ListChargeSections($filter: ModelChargeSectionFilterInput, $limit: Int, $nextToken: String) {
  listChargeSections(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      attachedToSectionId
      chargeId
      checkpoints {
        allocate
        pay
        payReasons
        read
        resolve
        sort
        tenant
        __typename
      }
      charge {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        payableAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        creatorEmail
        createdById
        contractorId
        recipientId
        documentId
        sectionId
        readId
        clientId
        openChargeClientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      duplicateCandidates {
        reason
        sectionId
        __typename
      }
      envelopeId
      envelope {
        id
        channel
        decryptedS3Key
        duplicateOfEnvelopeId
        encryption
        fileHash
        fileId
        importRunId
        mimeType
        originalFileName
        pages
        readFailure
        receivedAt
        s3Key
        setAsideReason
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      excludedPages
      fallbackIdentityKey
      genre
      genreCandidates {
        genre
        reasons
        score
        __typename
      }
      genreSubKind
      identity {
        documentNumber
        grossTotal
        issuer
        source
        __typename
      }
      identityKey
      index
      issueDate
      issuerDateKey
      issuerNumberKey
      readFailure
      pageRange {
        from
        to
        __typename
      }
      renderings {
        attachedAt
        envelopeId
        reason
        sectionId
        source
        __typename
      }
      setAsideReason
      splitSource
      state
      valuesFromSectionId
      resolvedAliases
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listChargeStatements = /* GraphQL */ `query ListChargeStatements($filter: ModelChargeStatementFilterInput, $limit: Int, $nextToken: String) {
  listChargeStatements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      charge {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        payableAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        creatorEmail
        createdById
        contractorId
        recipientId
        documentId
        sectionId
        readId
        clientId
        openChargeClientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      chargeId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listClientOrganizations = /* GraphQL */ `query ListClientOrganizations {
  listClientOrganizations {
    id
    name
    accountType
    contactId
    createdAt
    pendingDeletion
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      email
      language
      vat
      businessNumber
      addressId
      __typename
    }
    stats {
      activeMembers
      computedAt
      membersByStatus {
        count
        status
        __typename
      }
      rootUserName
      units
      unitsByType {
        count
        type
        __typename
      }
      __typename
    }
    __typename
  }
}
`;

export const listCommunications = /* GraphQL */ `query ListCommunications($filter: ModelCommunicationFilterInput, $limit: Int, $nextToken: String) {
  listCommunications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCommunicationSettingsProfiles = /* GraphQL */ `query ListCommunicationSettingsProfiles($filter: ModelCommunicationSettingsProfileFilterInput, $limit: Int, $nextToken: String) {
  listCommunicationSettingsProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      communicationsSettings {
        channels
        communicationType
        daysBeforeDueDate
        daysOverdue
        invoiceDaysAfterPeriodStart
        sendingRule
        recipients
        recipientsInBcc
        recipientsInCopy
        displayOpenBalance
        __typename
      }
      defaultName
      isDefaultSetting
      referent
      tenantStatementView
      replacementId
      displayLogo
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCompanyUsers = /* GraphQL */ `query ListCompanyUsers($filter: ModelCompanyUserFilterInput, $limit: Int, $nextToken: String) {
  listCompanyUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listContacts = /* GraphQL */ `query ListContacts($filter: ModelContactFilterInput, $limit: Int, $nextToken: String) {
  listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCounterpartyIdentities = /* GraphQL */ `query ListCounterpartyIdentities($filter: ModelCounterpartyIdentityFilterInput, $limit: Int, $nextToken: String) {
  listCounterpartyIdentities(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      keyType
      key
      isFullRemittance
      kind
      contactId
      source
      status
      evidenceCount
      firstSeenAt
      lastSeenAt
      lastCounterpartName
      lastDecisionId
      evidenceTransactionIds
      exclusionReason
      exclusionComment
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCounterpartyRoles = /* GraphQL */ `query ListCounterpartyRoles($filter: ModelCounterpartyRoleFilterInput, $limit: Int, $nextToken: String) {
  listCounterpartyRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subjectId
      targetType
      targetId
      source
      status
      evidenceCount
      lastSeenAt
      lastDecisionId
      evidenceTransactionIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCreditCosts = /* GraphQL */ `query ListCreditCosts($filter: ModelCreditCostFilterInput, $limit: Int, $nextToken: String) {
  listCreditCosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clientId
      endDate
      numberOfCredits
      price
      startDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCreditUsageCosts = /* GraphQL */ `query ListCreditUsageCosts($filter: ModelCreditUsageCostFilterInput, $limit: Int, $nextToken: String) {
  listCreditUsageCosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      endDate
      numberOfCreditsPerOperation
      startDate
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCustomFields = /* GraphQL */ `query ListCustomFields($filter: ModelCustomFieldFilterInput, $limit: Int, $nextToken: String) {
  listCustomFields(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      fieldName
      fieldType
      foreignKey
      foreignTableName
      labels {
        language
        label
        __typename
      }
      customFieldProperties {
        isRequired
        isDefault
        defaultValue
        __typename
      }
      order
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listCustomSubscriptions = /* GraphQL */ `query ListCustomSubscriptions($filter: ModelCustomSubscriptionFilterInput, $limit: Int, $nextToken: String) {
  listCustomSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      value
      userId
      _ttl
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listDocumentCategories = /* GraphQL */ `query ListDocumentCategories($filter: ModelDocumentCategoryFilterInput, $limit: Int, $nextToken: String) {
  listDocumentCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listDocumentExtractions = /* GraphQL */ `query ListDocumentExtractions($filter: ModelDocumentExtractionFilterInput, $limit: Int, $nextToken: String) {
  listDocumentExtractions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      corrected
      createdBy
      evidence {
        bbox
        field
        method
        page
        quote
        rawConfidence
        __typename
      }
      flags
      raw
      reasons
      score
      sectionId
      version
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listDocumentNumbers = /* GraphQL */ `query ListDocumentNumbers($filter: ModelDocumentNumberFilterInput, $limit: Int, $nextToken: String) {
  listDocumentNumbers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      format
      lastUpdate
      incrementNumber
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listEntityAliases = /* GraphQL */ `query ListEntityAliases($filter: ModelEntityAliasFilterInput, $limit: Int, $nextToken: String) {
  listEntityAliases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      confirmations
      confirmedBy
      key
      kind
      lastSeenAt
      lookupKey
      printedValue
      senderKeyType
      source
      targetId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listEntityRelations = /* GraphQL */ `query ListEntityRelations($filter: ModelEntityRelationFilterInput, $limit: Int, $nextToken: String) {
  listEntityRelations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      sourceId
      sourceTableName
      foreignId
      foreignTableName
      linkDescription
      linkProperties {
        __typename
      }
      clientId
      readers
      readId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listFeeArrearses = /* GraphQL */ `query ListFeeArrearses($filter: ModelFeeArrearsFilterInput, $limit: Int, $nextToken: String) {
  listFeeArrearses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accumulatedFrom {
        accumulatedAt
        amount
        paymentOrderId
        __typename
      }
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      openedAt
      originalAmount
      originPaymentOrderId
      originPaymentOrder {
        id
        amount
        anomalies
        anomalyAcknowledgedAt
        anomalyAcknowledgedBy
        anomalyPreviousIban
        anomalyReferenceAmount
        approvedAt
        approvedBy
        bankAccountId
        buildingId
        cancelledAt
        cancelledBy
        cancelReasonCode
        channel
        confirmationDeadlineDate
        counterpartAccountNumber
        counterpartContactId
        counterpartAccountUpdatedAt
        counterpartAccountUpdatedBy
        counterpartName
        counterpartRemittanceInformation
        createdBy
        dueDate
        executedDate
        executedAt
        executedBy
        executedTransactionId
        feeArrearsId
        fixedAt
        fixedBy
        invoiceId
        issuedAt
        issuedBy
        ownerContactId
        paymentBatchId
        periodFrom
        reconciledAt
        recurringPaymentTemplateId
        reference
        reissuedFromOrderId
        reissuedOrderId
        rejectedAt
        rejectedBy
        rejectedField
        rejectedReason
        requestedAmount
        reroutedAt
        reroutedBy
        reroutedFromBankAccountId
        status
        submittedAt
        submittedBy
        suggestionDeclinedReason
        suggestionResolved
        tenantRechargeableRatio
        type
        unitId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerContactId
      ownerContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      servedBy {
        amount
        paymentOrderId
        servedAt
        __typename
      }
      settledAt
      status
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listFiles = /* GraphQL */ `query ListFiles($filter: ModelFileFilterInput, $limit: Int, $nextToken: String) {
  listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listFilterGroups = /* GraphQL */ `query ListFilterGroups($filter: ModelFilterGroupFilterInput, $limit: Int, $nextToken: String) {
  listFilterGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      filterGroupDetails {
        filterEntityType
        filterEntityField
        filterEntityValues
        filterEntityNumber
        filterEntityDate
        __typename
      }
      name
      screenName
      type
      userId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listImportRuns = /* GraphQL */ `query ListImportRuns($filter: ModelImportRunFilterInput, $limit: Int, $nextToken: String) {
  listImportRuns(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      channel
      files
      finishedAt
      handled
      needsYou
      reviewEverything
      sections
      setAside
      startedAt
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listIntegrations = /* GraphQL */ `query ListIntegrations($filter: ModelIntegrationFilterInput, $limit: Int, $nextToken: String) {
  listIntegrations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      configurations {
        name
        value
        __typename
      }
      error
      lastRun
      name
      status
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listInternalComments = /* GraphQL */ `query ListInternalComments($filter: ModelInternalCommentFilterInput, $limit: Int, $nextToken: String) {
  listInternalComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      authorId
      content
      entityId
      entityType
      kind
      mentionedUserIds
      userIdsReactions {
        reactionType
        userId
        __typename
      }
      replyToId
      attachmentFileIds
      systemMessage
      systemMessageParameters
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listInvoices = /* GraphQL */ `query ListInvoices($filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String) {
  listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listInvoiceSettings = /* GraphQL */ `query ListInvoiceSettings($filter: ModelInvoiceSettingFilterInput, $limit: Int, $nextToken: String) {
  listInvoiceSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      creditNoteFormat
      creditNoteLastUpdate
      creditNoteIncrementNumber
      invoiceFormat
      invoiceLastUpdate
      invoiceIncrementNumber
      paymentRequestFormat
      paymentRequestLastUpdate
      paymentRequestIncrementNumber
      receiptFormat
      receiptLastUpdate
      receiptIncrementNumber
      variousOperationFormat
      variousOperationLastUpdate
      variousOperationIncrementNumber
      customInvoicingConfiguration
      defaultVatRateId
      fiscalYearStart
      allPurposeInvoiceIssuer
      paymentBankAccountId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLearningEvents = /* GraphQL */ `query ListLearningEvents($filter: ModelLearningEventFilterInput, $limit: Int, $nextToken: String) {
  listLearningEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      at
      field
      from
      kind
      layoutId
      senderId
      to
      userId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLeaseActionHistories = /* GraphQL */ `query ListLeaseActionHistories($filter: ModelLeaseActionHistoryFilterInput, $limit: Int, $nextToken: String) {
  listLeaseActionHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      action
      comment
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      historyDetails {
        unitId
        newEndDate
        newSignatureDate
        newStartDate
        previousEndDate
        previousSignatureDate
        previousStartDate
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      communicationChannel
      communicationSendDate
      communicationByPlatform
      endReason
      endReasonOwnUseRelation
      endReasonOwnUseName
      initiator
      totalAmount
      totalAmountLabel
      automatic
      hasLeaseTypeChanged
      jiraId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLeaseAdditionalClauses = /* GraphQL */ `query ListLeaseAdditionalClauses($filter: ModelLeaseAdditionalClauseFilterInput, $limit: Int, $nextToken: String) {
  listLeaseAdditionalClauses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      title
      body
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLeaseContacts = /* GraphQL */ `query ListLeaseContacts($filter: ModelLeaseContactFilterInput, $limit: Int, $nextToken: String) {
  listLeaseContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      leaseId
      contactId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactRole
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLeasePriceHistories = /* GraphQL */ `query ListLeasePriceHistories($filter: ModelLeasePriceHistoryFilterInput, $limit: Int, $nextToken: String) {
  listLeasePriceHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLeases = /* GraphQL */ `query ListLeases($filter: ModelLeaseFilterInput, $limit: Int, $nextToken: String) {
  listLeases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listLeaseVariousOperations = /* GraphQL */ `query ListLeaseVariousOperations($filter: ModelLeaseVariousOperationFilterInput, $limit: Int, $nextToken: String) {
  listLeaseVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listMortgages = /* GraphQL */ `query ListMortgages($filter: ModelMortgageFilterInput, $limit: Int, $nextToken: String) {
  listMortgages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      lender
      durationInYears
      rateType
      interestRate
      aprRate
      startDate
      amount
      monthlyPayment
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listNotifications = /* GraphQL */ `query ListNotifications($filter: ModelNotificationFilterInput, $limit: Int, $nextToken: String) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdBy
      type
      message
      popupDate
      expirationDate
      status
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicId
      technic {
        id
        type
        technicLibraryId
        technicName
        lastControlDate
        status
        contractNumber
        communicationSettingsProfileId
        utilityType
        utilityEanCode
        utilityMeterNumber
        utilityDistributorId
        buildingId
        unitId
        leaseId
        contactId
        originalTechnicId
        replacedTechnicId
        certificateIds
        readers
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ticketId
      ticket {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listPaymentBatchs = /* GraphQL */ `query ListPaymentBatchs($filter: ModelPaymentBatchFilterInput, $limit: Int, $nextToken: String) {
  listPaymentBatchs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listPaymentOrders = /* GraphQL */ `query ListPaymentOrders($filter: ModelPaymentOrderFilterInput, $limit: Int, $nextToken: String) {
  listPaymentOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listPostings = /* GraphQL */ `query ListPostings($filter: ModelPostingFilterInput, $limit: Int, $nextToken: String) {
  listPostings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      class
      customLabel
      customValues {
        name
        value
        __typename
      }
      topClass
      type
      totalAmount
      periodFrom
      periodTo
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      chargeId
      charge {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        payableAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        creatorEmail
        createdById
        contractorId
        recipientId
        documentId
        sectionId
        readId
        clientId
        openChargeClientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      transactionId
      transaction {
        id
        status
        snoozedUntil
        sequence
        statementDate
        operationDate
        remittanceInformationType
        remittanceInformation
        remittanceInformationRaw
        additionalInformation
        structuredCommunication
        bankTransactionCode
        proprietaryBankTransactionCode
        endToEndId
        mandateId
        creditorId
        purposeCode
        internalReference
        comment
        exclusionReason
        exclusionComment
        excludedAt
        excludedBy
        amount
        bankAccountId
        counterpartName
        counterpartDisplayName
        counterpartAccountNumber
        origin
        sourceChannel
        nativeTransactionId
        fingerprint
        linkedSourceChannels
        proposedLeaseId
        proposedUnitId
        proposedContractorId
        proposedOwnerId
        proposedMatch
        proposedAllocation
        classification
        classificationConfidence
        classificationReason
        recurrence
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      accountLabelId
      accountLabel {
        id
        bankAccountId
        contactId
        class
        customUsage
        disabled
        hoaFundId
        ownerId
        topClass
        vatNonDeductiblePercentage
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationId
      leaseVariousOperation {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      amountVatExcluded
      vatAmount
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      vatRateId
      vatRateValue
      foreignId
      foreignType
      invoicePostingId
      reconciledAt
      decisionId
      status
      chargeOwnerRepartition
      chargeRepartitionMetric
      chargeRepartitionValue
      chargeSplitNumber
      chargeType
      tenantShare {
        basis
        mode
        percentage
        __typename
      }
      provisional
      flaggedAt
      carriedForward
      tenantLandings {
        amount
        amountVatExcluded
        days
        leaseId
        periodFrom
        periodTo
        statementId
        vatAmount
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listReconciliationDecisions = /* GraphQL */ `query ListReconciliationDecisions($filter: ModelReconciliationDecisionFilterInput, $limit: Int, $nextToken: String) {
  listReconciliationDecisions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      decisionId
      transactionId
      relatedTransactionIds
      kind
      status
      source
      trigger
      actorId
      outcome
      score
      reasonCodes
      flowType
      amount
      links {
        amount
        linkId
        linkType
        __typename
      }
      allocations {
        invoiceId
        postingId
        amount
        awaitingPosting
        __typename
      }
      exclusionReason
      comment
      snoozedUntil
      reversesDecisionId
      appliesDecisionId
      decidedAt
      backfilled
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listReconciliationSettings = /* GraphQL */ `query ListReconciliationSettings($filter: ModelReconciliationSettingFilterInput, $limit: Int, $nextToken: String) {
  listReconciliationSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      allocationMode
      leaseId
      ownerId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listRecurringPaymentTemplates = /* GraphQL */ `query ListRecurringPaymentTemplates($filter: ModelRecurringPaymentTemplateFilterInput, $limit: Int, $nextToken: String) {
  listRecurringPaymentTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amountVersions {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      beneficiaryBankAccountId
      beneficiaryBankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      beneficiaryContactId
      beneficiaryContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdBy
      endDate
      endedAt
      endedBy
      firstPeriodFrom
      funds {
        accountLabelId
        fundId
        remittanceInformation
        __typename
      }
      generationDay
      lastGeneratedPeriodFrom
      name
      periodicity
      remittanceInformation
      splitTransfers
      status
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listReleaseNotes = /* GraphQL */ `query ListReleaseNotes($filter: ModelReleaseNoteFilterInput, $limit: Int, $nextToken: String) {
  listReleaseNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      publishedAt
      visibleToOwners
      contents {
        language
        title
        body
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listRepartitionKeys = /* GraphQL */ `query ListRepartitionKeys($filter: ModelRepartitionKeyFilterInput, $limit: Int, $nextToken: String) {
  listRepartitionKeys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      type
      accountLabelId
      accountLabel {
        id
        bankAccountId
        contactId
        class
        customUsage
        disabled
        hoaFundId
        ownerId
        topClass
        vatNonDeductiblePercentage
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitRepartition {
        unitId
        value
        __typename
      }
      ownerRepartition
      tenantRepartition
      repartitionMetric
      technics
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listRepaymentStatements = /* GraphQL */ `query ListRepaymentStatements($filter: ModelRepaymentStatementFilterInput, $limit: Int, $nextToken: String) {
  listRepaymentStatements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountOwnership
      delaysCleared
      expectedRent
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      rentsCollected
      repaymentStatementDetails {
        class
        customLabel
        invoiceId
        invoicePostingId
        originalTotalAmount
        periodFrom
        periodTo
        totalAmount
        transactionId
        type
        __typename
      }
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      totalReceivedInJointAccount
      totalExpectedInOwnerAccount
      unpaidRents
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listScheduleRules = /* GraphQL */ `query ListScheduleRules($filter: ModelScheduleRuleFilterInput, $limit: Int, $nextToken: String) {
  listScheduleRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conditions {
        comparisonMode
        operator
        values
        valueKind
        __typename
      }
      conditionsOperator
      foreignKey
      foreignTableName
      name {
        language
        label
        __typename
      }
      order
      outcome {
        type
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listSenderRules = /* GraphQL */ `query ListSenderRules($filter: ModelSenderRuleFilterInput, $limit: Int, $nextToken: String) {
  listSenderRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      senderId
      sender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      kind
      scope {
        accountClass
        identifierKind
        identifierValue
        labelKey
        ownerId
        __typename
      }
      value {
        accountLabelId
        encodesInvoiceNumber
        paymentOnReceipt
        paymentTermDays
        privateExpense
        recoverabilityMode
        recoverabilityPercentage
        reminderFees
        roundingPrecision
        vatRateValues
        __typename
      }
      source
      confirmations
      updatedBy
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listSendingSources = /* GraphQL */ `query ListSendingSources($filter: ModelSendingSourceFilterInput, $limit: Int, $nextToken: String) {
  listSendingSources(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dnsRecords {
        name
        type
        value
        __typename
      }
      emailAddress
      issuesEmail
      chargesEmail
      errorMessage
      name
      lastReminderDate
      status
      statusLastVerification
      verifiedType
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listSettings = /* GraphQL */ `query ListSettings($filter: ModelSettingFilterInput, $limit: Int, $nextToken: String) {
  listSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      value
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listSignatureDocuments = /* GraphQL */ `query ListSignatureDocuments($filter: ModelSignatureDocumentFilterInput, $limit: Int, $nextToken: String) {
  listSignatureDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listStatements = /* GraphQL */ `query ListStatements($filter: ModelStatementFilterInput, $limit: Int, $nextToken: String) {
  listStatements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listStatementSettings = /* GraphQL */ `query ListStatementSettings($filter: ModelStatementSettingFilterInput, $limit: Int, $nextToken: String) {
  listStatementSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      custom
      disabled
      monthFrequency
      startMonth
      generationDay
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listSubscriptionUsageHistories = /* GraphQL */ `query ListSubscriptionUsageHistories($filter: ModelSubscriptionUsageHistoryFilterInput, $limit: Int, $nextToken: String) {
  listSubscriptionUsageHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTags = /* GraphQL */ `query ListTags($filter: ModelTagFilterInput, $limit: Int, $nextToken: String) {
  listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      color
      foreignTableName
      labels {
        language
        label
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTechnicLibraries = /* GraphQL */ `query ListTechnicLibraries($filter: ModelTechnicLibraryFilterInput, $limit: Int, $nextToken: String) {
  listTechnicLibraries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTechnics = /* GraphQL */ `query ListTechnics($filter: ModelTechnicFilterInput, $limit: Int, $nextToken: String) {
  listTechnics(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTemplates = /* GraphQL */ `query ListTemplates($filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String) {
  listTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      language
      name
      subject
      subjectRawFormat
      body
      bodyRawFormat
      type
      subType
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTickets = /* GraphQL */ `query ListTickets($filter: ModelTicketFilterInput, $limit: Int, $nextToken: String) {
  listTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTransactionRules = /* GraphQL */ `query ListTransactionRules($filter: ModelTransactionRuleFilterInput, $limit: Int, $nextToken: String) {
  listTransactionRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      isFullRemittance
      remittanceInformation
      counterpartName
      counterpartAccountNumber
      usedFields
      exclude
      exclusionReason
      exclusionComment
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listTransactions = /* GraphQL */ `query ListTransactions($filter: ModelTransactionFilterInput, $limit: Int, $nextToken: String) {
  listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listUnitEvents = /* GraphQL */ `query ListUnitEvents($filter: ModelUnitEventFilterInput, $limit: Int, $nextToken: String) {
  listUnitEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      unitId
      type
      startDate
      endDate
      totalCost
      note
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listUnitInventories = /* GraphQL */ `query ListUnitInventories($filter: ModelUnitInventoryFilterInput, $limit: Int, $nextToken: String) {
  listUnitInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      privateBatthRoom
      deletedAt
      kitchenEquipment
      roomName
      roomType
      surface
      showSurface
      unitId
      inside
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listUnitLeases = /* GraphQL */ `query ListUnitLeases($filter: ModelUnitLeaseFilterInput, $limit: Int, $nextToken: String) {
  listUnitLeases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      allowChargeAdjustment
      authorizeProfessionalActivity
      chargesIndexation
      endDate
      furnishedRental
      furnishedRentalInsuranceByTenant
      furnishedRentalRentalPricePercentage
      initialRentalPrice
      indexation
      advancedIndexation
      indexType
      baseYear
      baseIndexType
      baseIndexDate
      nextIndexationMonth
      nextIndexation
      leaseId
      mainUnit
      rentalPrice
      signatureDate
      startDate
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listUnitOwners = /* GraphQL */ `query ListUnitOwners($filter: ModelUnitOwnerFilterInput, $limit: Int, $nextToken: String) {
  listUnitOwners(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      disabled
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerId
      periodFrom
      periodTo
      stake
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listUnits = /* GraphQL */ `query ListUnits($filter: ModelUnitFilterInput, $limit: Int, $nextToken: String) {
  listUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listValuations = /* GraphQL */ `query ListValuations($filter: ModelValuationFilterInput, $limit: Int, $nextToken: String) {
  listValuations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      sourceType
      valorization
      date
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listVariousOperations = /* GraphQL */ `query ListVariousOperations($filter: ModelVariousOperationFilterInput, $limit: Int, $nextToken: String) {
  listVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      amount
      labels {
        language
        label
        __typename
      }
      numberOfMonths
      operationType
      paymentFrequency
      type
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const listVatRates = /* GraphQL */ `query ListVatRates($filter: ModelVatRateFilterInput, $limit: Int, $nextToken: String) {
  listVatRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const membersByClientId = /* GraphQL */ `query MembersByClientId($input: MembersByClientIdInput!) {
  membersByClientId(input: $input) {
    betterAuthUserId
    clientId
    contactId
    dynamoUserId
    email
    firstName
    lastName
    name
    phoneNumber
    phoneNumberVerified
    role
    rootUser
    status
    userRoleId
    __typename
  }
}
`;

export const membersByContactId = /* GraphQL */ `query MembersByContactId($input: MembersByContactIdInput!) {
  membersByContactId(input: $input) {
    betterAuthUserId
    clientId
    contactId
    dynamoUserId
    email
    status
    __typename
  }
}
`;

export const openInvoices = /* GraphQL */ `query OpenInvoices($scope: ScopeInput!, $filter: OpenInvoiceFilter, $after: String) {
  openInvoices(scope: $scope, filter: $filter, after: $after) {
    accounts {
      balance
      id
      isAgencyAccount
      label
      number
      projectedBalance
      retainedBalanceThreshold
      type
      __typename
    }
    endCursor
    groupTotals {
      amount
      count
      grouping
      key
      __typename
    }
    hasMore
    items {
      allocation
      allocationLines {
        amount
        basis
        buildingId
        detail
        label
        share
        unitId
        __typename
      }
      amount
      buildingId
      buildingName
      defaultBankAccountId
      dueDate
      eligibleAccountIds
      iban
      ibanState
      id
      invoiceDate
      label
      ownerContactId
      payDate
      paymentTermDays
      rechargeableRatio
      selectable
      supplierContactId
      supplierName
      type
      __typename
    }
    lensCounts {
      all
      alloc
      iban
      ready
      __typename
    }
    ownerIds
    totalAmount
    totalCount
    __typename
  }
}
`;

export const openInvoicesSummary = /* GraphQL */ `query OpenInvoicesSummary($scope: ScopeInput!) {
  openInvoicesSummary(scope: $scope) {
    accounts {
      balance
      id
      isAgencyAccount
      label
      number
      projectedBalance
      retainedBalanceThreshold
      type
      __typename
    }
    feeCount
    needsAllocationCount
    supplierCount
    topUrgent {
      allocation
      allocationLines {
        amount
        basis
        buildingId
        detail
        label
        share
        unitId
        __typename
      }
      amount
      buildingId
      buildingName
      defaultBankAccountId
      dueDate
      eligibleAccountIds
      iban
      ibanState
      id
      invoiceDate
      label
      ownerContactId
      payDate
      paymentTermDays
      rechargeableRatio
      selectable
      supplierContactId
      supplierName
      type
      __typename
    }
    totalAmount
    totalCount
    __typename
  }
}
`;

export const paymentOrders = /* GraphQL */ `query PaymentOrders($scope: ScopeInput!, $filter: PaymentOrderFilter, $after: String) {
  paymentOrders(scope: $scope, filter: $filter, after: $after) {
    accountGroups {
      amount
      bankAccountId
      count
      __typename
    }
    endCursor
    groups {
      amount
      count
      type
      __typename
    }
    hasMore
    items {
      amount
      anomalies
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      beneficiaryBankAccountId
      beneficiaryIban
      beneficiaryIbanReplaced
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      beneficiaryIbanState
      beneficiaryName
      buildingId
      buildingName
      bulkApprovable
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      collectedFee
      confirmationDeadlineDate
      confirmationOverdue
      counterpartContactId
      counterpartRemittanceInformation
      createdBy
      dueDate
      eligibleRerouteAccountIds
      executedAt
      executedBy
      executedDate
      executedTransactionId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      id
      invoiceId
      issuedAt
      issuedBy
      paymentBatchId
      periodFrom
      recurringPaymentTemplateId
      recurringPendingCount
      recurringPendingRank
      reference
      reissuable
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      selectable
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      __typename
    }
    overdueCount
    ownerIds
    recentlyReconciledCount
    toConfirmCount
    toValidateCount
    toValidateForCallerAmount
    toValidateForCallerCount
    totalAmount
    totalCount
    __typename
  }
}
`;

export const paymentRunSummary = /* GraphQL */ `query PaymentRunSummary($scope: ScopeInput!) {
  paymentRunSummary(scope: $scope) {
    accountCount
    accounts {
      accountId
      heldCount
      heldTotal
      paidNow
      shortfall
      verdict
      __typename
    }
    heldCount
    heldTotal
    paidNowTotal
    shortAccountCount
    __typename
  }
}
`;

export const publishedIndexValue = /* GraphQL */ `query PublishedIndexValue($month: AWSDate!, $baseYear: Int!, $indexType: IndexType) {
  publishedIndexValue(month: $month, baseYear: $baseYear, indexType: $indexType)
}
`;

export const recurringPayments = /* GraphQL */ `query RecurringPayments($scope: ScopeInput!) {
  recurringPayments(scope: $scope) {
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryContactId
    currentAmountVersion {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    endDate
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generatedThisMonthAmount
    generatedThisMonthOrderCount
    generationDay
    id
    name
    nextDueDate
    oldestPendingPeriodFrom
    pendingAmount
    pendingPeriodCount
    periodicity
    remittanceInformation
    splitTransfers
    status
    underfunded
    unitId
    __typename
  }
}
`;

export const rentMatrix = /* GraphQL */ `query RentMatrix($filter: RentFilter, $fiscalYear: Int!, $groupBy: RentGroupBy, $mode: RentValueMode!, $page: PageInput, $rowView: RentRowKind, $scope: ScopeInput!, $sort: RentSort) {
  rentMatrix(filter: $filter, fiscalYear: $fiscalYear, groupBy: $groupBy, mode: $mode, page: $page, rowView: $rowView, scope: $scope, sort: $sort) {
    dataVersion
    groups {
      count
      key
      label
      __typename
    }
    minFiscalYear
    monthlyTotals
    pageInfo {
      hasMore
      __typename
    }
    rows {
      buildingIds
      buildingNames
      cells {
        coveredDueDate
        coveredStatus
        due
        forecast
        invoiceId
        leaseIds
        month
        paid
        reminderCount
        status
        __typename
      }
      cities
      isDispute
      leaseId
      leaseIds
      leaseLabel
      monthlyRent
      ownerIds
      pendingReconciliations
      rowId
      rowKind
      rowTotal
      tenantCreditBalance
      tenantName
      unitId
      unitIds
      units
      __typename
    }
    totalCount
    __typename
  }
}
`;

export const rentMatrixExport = /* GraphQL */ `query RentMatrixExport($filter: RentFilter, $fiscalYear: Int!, $groupBy: RentGroupBy, $language: Language, $layout: RentExportLayout, $mode: RentValueMode!, $rowView: RentRowKind, $scope: ScopeInput!, $sort: RentSort) {
  rentMatrixExport(filter: $filter, fiscalYear: $fiscalYear, groupBy: $groupBy, language: $language, layout: $layout, mode: $mode, rowView: $rowView, scope: $scope, sort: $sort) {
    content
    fileName
    rowCount
    status
    __typename
  }
}
`;

export const rentMatrixFilterOptions = /* GraphQL */ `query RentMatrixFilterOptions($fiscalYear: Int!, $rowView: RentRowKind, $scope: ScopeInput!) {
  rentMatrixFilterOptions(fiscalYear: $fiscalYear, rowView: $rowView, scope: $scope) {
    buildings {
      id
      label
      __typename
    }
    cities
    owners {
      id
      label
      __typename
    }
    units {
      id
      label
      __typename
    }
    __typename
  }
}
`;

export const rentMatrixRows = /* GraphQL */ `query RentMatrixRows($filter: RentFilter, $fiscalYear: Int!, $leaseIds: [ID!]!, $mode: RentValueMode!, $scope: ScopeInput!) {
  rentMatrixRows(filter: $filter, fiscalYear: $fiscalYear, leaseIds: $leaseIds, mode: $mode, scope: $scope) {
    dataVersion
    missingLeaseIds
    rows {
      buildingIds
      buildingNames
      cells {
        coveredDueDate
        coveredStatus
        due
        forecast
        invoiceId
        leaseIds
        month
        paid
        reminderCount
        status
        __typename
      }
      cities
      isDispute
      leaseId
      leaseIds
      leaseLabel
      monthlyRent
      ownerIds
      pendingReconciliations
      rowId
      rowKind
      rowTotal
      tenantCreditBalance
      tenantName
      unitId
      unitIds
      units
      __typename
    }
    __typename
  }
}
`;

export const sepaBatches = /* GraphQL */ `query SepaBatches($input: SepaBatchesInput!) {
  sepaBatches(input: $input) {
    endCursor
    hasMore
    items {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    summaries {
      batchId
      cancelledCount
      executedCount
      orderCount
      overdueCount
      pendingCount
      totalAmount
      __typename
    }
    __typename
  }
}
`;

export const sepaBatchFileUrl = /* GraphQL */ `query SepaBatchFileUrl($input: SepaBatchFileUrlInput!) {
  sepaBatchFileUrl(input: $input)
}
`;

export const sepaBatchOrders = /* GraphQL */ `query SepaBatchOrders($input: SepaBatchIdInput!) {
  sepaBatchOrders(input: $input) {
    amount
    anomalies
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    beneficiaryBankAccountId
    beneficiaryIban
    beneficiaryIbanReplaced
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    beneficiaryIbanState
    beneficiaryName
    buildingId
    buildingName
    bulkApprovable
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    collectedFee
    confirmationDeadlineDate
    confirmationOverdue
    counterpartContactId
    counterpartRemittanceInformation
    createdBy
    dueDate
    eligibleRerouteAccountIds
    executedAt
    executedBy
    executedDate
    executedTransactionId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    id
    invoiceId
    issuedAt
    issuedBy
    paymentBatchId
    periodFrom
    recurringPaymentTemplateId
    recurringPendingCount
    recurringPendingRank
    reference
    reissuable
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    selectable
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    __typename
  }
}
`;

export const signatureFiles = /* GraphQL */ `query SignatureFiles($input: SignatureFilesInput!) {
  signatureFiles(input: $input) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const supplierRegistry = /* GraphQL */ `query SupplierRegistry($contactId: ID!) {
  supplierRegistry(contactId: $contactId) {
    aliases {
      id
      confirmations
      confirmedBy
      key
      kind
      lastSeenAt
      lookupKey
      printedValue
      senderKeyType
      source
      targetId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    rules {
      id
      senderId
      sender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      kind
      scope {
        accountClass
        identifierKind
        identifierValue
        labelKey
        ownerId
        __typename
      }
      value {
        accountLabelId
        encodesInvoiceNumber
        paymentOnReceipt
        paymentTermDays
        privateExpense
        recoverabilityMode
        recoverabilityPercentage
        reminderFees
        roundingPrecision
        vatRateValues
        __typename
      }
      source
      confirmations
      updatedBy
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    __typename
  }
}
`;

export const syncAccountLabels = /* GraphQL */ `query SyncAccountLabels($filter: ModelAccountLabelFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAccountLabels(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAddresses = /* GraphQL */ `query SyncAddresses($filter: ModelAddressFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAddresses(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAdminCommunications = /* GraphQL */ `query SyncAdminCommunications($filter: ModelAdminCommunicationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAdminCommunications(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      body
      clientId
      externalId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      applicationInvoiceId
      recipient
      sentAt
      status
      subject
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAdminFiles = /* GraphQL */ `query SyncAdminFiles($filter: ModelAdminFileFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAdminFiles(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      bucket
      foreignKey
      foreignTableName
      key
      mimeType
      region
      size
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAdvertisements = /* GraphQL */ `query SyncAdvertisements($filter: ModelAdvertisementFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAdvertisements(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      type
      subType
      amenities
      amountOfFacades
      availabilityDate
      certificateOfConformity
      citationForPlanningOffence
      descriptions {
        language
        description
        __typename
      }
      delimitedZone
      floodProneArea
      furnished
      firstOccupancy
      gardenSurface
      heatingAmenities
      heatingType
      landTerrain
      landArea
      length
      nearbyComodities {
        type
        name
        distance
        __typename
      }
      publishedPlatforms {
        name
        publishedDate
        id
        __typename
      }
      planningPermission
      publishCadastralIncome
      resort
      rightOfPreemption
      subdivisionAuthorization
      wheelChairAccessible
      width
      terraceSurface
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAgencyRateOwners = /* GraphQL */ `query SyncAgencyRateOwners($filter: ModelAgencyRateOwnerFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAgencyRateOwners(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      agencyRateId
      contactId
      agencyRate {
        id
        amountMinimumFees
        custom
        feesAppliedTo
        includedInAmount
        name
        repartitionType
        type
        unitType
        vatRateId
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAgencyRates = /* GraphQL */ `query SyncAgencyRates($filter: ModelAgencyRateFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAgencyRates(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amountDetails {
        amountType
        endAmount
        feeApplied
        startAmount
        __typename
      }
      rateWhenVacant {
        amount
        type
        __typename
      }
      amountMinimumFees
      custom
      feesAppliedTo
      includedInAmount
      name
      owners {
        nextToken
        startedAt
        __typename
      }
      repartitionType
      type
      unitType
      vatRateId
      unitIds
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncAgencyRateStatements = /* GraphQL */ `query SyncAgencyRateStatements($filter: ModelAgencyRateStatementFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncAgencyRateStatements(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      agencyRate {
        id
        amountMinimumFees
        custom
        feesAppliedTo
        includedInAmount
        name
        repartitionType
        type
        unitType
        vatRateId
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      unitAmounts {
        unitId
        amountRateable
        fixedAmount
        __typename
      }
      totalAmountRateable
      totalFixedAmount
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncApplicationInvoiceLines = /* GraphQL */ `query SyncApplicationInvoiceLines($filter: ModelApplicationInvoiceLineFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncApplicationInvoiceLines(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amountVatExcluded
      applicationInvoiceId
      applicationInvoice {
        id
        amount
        applicationSubscriptionId
        clientId
        dueDate
        invoiceDate
        invoiceNumber
        periodFrom
        periodTo
        status
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      calculationDetail {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      clientId
      customLabel
      extraInformation
      quantity
      periodFrom
      periodTo
      subscriptionVariousOperationId
      subscriptionVariousOperation {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      subscriptionUsageHistoryId
      subscriptionUsageHistory {
        id
        clientId
        customerCreatorId
        requestId
        applicationInvoiceId
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      totalAmount
      type
      vatAmount
      vatRate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncApplicationInvoices = /* GraphQL */ `query SyncApplicationInvoices($filter: ModelApplicationInvoiceFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncApplicationInvoices(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncApplicationPlans = /* GraphQL */ `query SyncApplicationPlans($filter: ModelApplicationPlanFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncApplicationPlans(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncApplicationSubscriptions = /* GraphQL */ `query SyncApplicationSubscriptions($filter: ModelApplicationSubscriptionFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncApplicationSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncApplicationSubscriptionVariousOperations = /* GraphQL */ `query SyncApplicationSubscriptionVariousOperations($filter: ModelApplicationSubscriptionVariousOperationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncApplicationSubscriptionVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncApplicationVariousOperations = /* GraphQL */ `query SyncApplicationVariousOperations($filter: ModelApplicationVariousOperationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncApplicationVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amount
      applicationPlanIncludedVariousOperationsId
      customerVisible
      duration
      labels {
        language
        label
        __typename
      }
      numberOfCredits
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncBankAccounts = /* GraphQL */ `query SyncBankAccounts($filter: ModelBankAccountFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncBankAccounts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncBillingItems = /* GraphQL */ `query SyncBillingItems($filter: ModelBillingItemFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncBillingItems(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      name
      baseAmount
      billingType
      amountCalculationType
      percentageBase
      period
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      quantity
      percentage
      allocationOption
      multipleUnitsSplit
      leaseIds
      unitIds
      buildingIds
      accountLabelId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncBuildingEvents = /* GraphQL */ `query SyncBuildingEvents($filter: ModelBuildingEventFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncBuildingEvents(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      buildingId
      type
      startDate
      endDate
      totalCost
      note
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncBuildingOwners = /* GraphQL */ `query SyncBuildingOwners($filter: ModelBuildingOwnerFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncBuildingOwners(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      disabled
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      periodTo
      stake
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncBuildings = /* GraphQL */ `query SyncBuildings($filter: ModelBuildingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncBuildings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncBuildingSites = /* GraphQL */ `query SyncBuildingSites($filter: ModelBuildingSiteFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncBuildingSites(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCashExpectations = /* GraphQL */ `query SyncCashExpectations($filter: ModelCashExpectationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCashExpectations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      sourceType
      sourceId
      direction
      flowType
      status
      accountIds
      originalAmount
      openAmount
      disputedAmount
      expectedAmount
      issueDate
      dueDate
      confirmationDeadline
      structuredCommunication
      invoiceNumber
      reference
      counterpartyIban
      leaseId
      unitId
      ownerId
      contractorId
      isOffLedgerReceivable
      awaitingPosting
      lines {
        postingId
        accountClass
        originalAmount
        openAmount
        disputed
        periodFrom
        periodTo
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCauses = /* GraphQL */ `query SyncCauses($filter: ModelCauseFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCauses(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      distinctValues {
        display
        sectionIds
        value
        __typename
      }
      importRunId
      key
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncChargeEnvelopes = /* GraphQL */ `query SyncChargeEnvelopes($filter: ModelChargeEnvelopeFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncChargeEnvelopes(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCharges = /* GraphQL */ `query SyncCharges($filter: ModelChargeFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCharges(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncChargeSections = /* GraphQL */ `query SyncChargeSections($filter: ModelChargeSectionFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncChargeSections(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      attachedToSectionId
      chargeId
      checkpoints {
        allocate
        pay
        payReasons
        read
        resolve
        sort
        tenant
        __typename
      }
      charge {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        payableAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        creatorEmail
        createdById
        contractorId
        recipientId
        documentId
        sectionId
        readId
        clientId
        openChargeClientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      duplicateCandidates {
        reason
        sectionId
        __typename
      }
      envelopeId
      envelope {
        id
        channel
        decryptedS3Key
        duplicateOfEnvelopeId
        encryption
        fileHash
        fileId
        importRunId
        mimeType
        originalFileName
        pages
        readFailure
        receivedAt
        s3Key
        setAsideReason
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      excludedPages
      fallbackIdentityKey
      genre
      genreCandidates {
        genre
        reasons
        score
        __typename
      }
      genreSubKind
      identity {
        documentNumber
        grossTotal
        issuer
        source
        __typename
      }
      identityKey
      index
      issueDate
      issuerDateKey
      issuerNumberKey
      readFailure
      pageRange {
        from
        to
        __typename
      }
      renderings {
        attachedAt
        envelopeId
        reason
        sectionId
        source
        __typename
      }
      setAsideReason
      splitSource
      state
      valuesFromSectionId
      resolvedAliases
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncChargeStatements = /* GraphQL */ `query SyncChargeStatements($filter: ModelChargeStatementFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncChargeStatements(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      charge {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        payableAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        creatorEmail
        createdById
        contractorId
        recipientId
        documentId
        sectionId
        readId
        clientId
        openChargeClientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      chargeId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCommunications = /* GraphQL */ `query SyncCommunications($filter: ModelCommunicationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCommunications(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCommunicationSettingsProfiles = /* GraphQL */ `query SyncCommunicationSettingsProfiles($filter: ModelCommunicationSettingsProfileFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCommunicationSettingsProfiles(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      communicationsSettings {
        channels
        communicationType
        daysBeforeDueDate
        daysOverdue
        invoiceDaysAfterPeriodStart
        sendingRule
        recipients
        recipientsInBcc
        recipientsInCopy
        displayOpenBalance
        __typename
      }
      defaultName
      isDefaultSetting
      referent
      tenantStatementView
      replacementId
      displayLogo
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCompanyUsers = /* GraphQL */ `query SyncCompanyUsers($filter: ModelCompanyUserFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCompanyUsers(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncContacts = /* GraphQL */ `query SyncContacts($filter: ModelContactFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncContacts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCounterpartyIdentities = /* GraphQL */ `query SyncCounterpartyIdentities($filter: ModelCounterpartyIdentityFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCounterpartyIdentities(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      keyType
      key
      isFullRemittance
      kind
      contactId
      source
      status
      evidenceCount
      firstSeenAt
      lastSeenAt
      lastCounterpartName
      lastDecisionId
      evidenceTransactionIds
      exclusionReason
      exclusionComment
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCounterpartyRoles = /* GraphQL */ `query SyncCounterpartyRoles($filter: ModelCounterpartyRoleFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCounterpartyRoles(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      subjectId
      targetType
      targetId
      source
      status
      evidenceCount
      lastSeenAt
      lastDecisionId
      evidenceTransactionIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCreditCosts = /* GraphQL */ `query SyncCreditCosts($filter: ModelCreditCostFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCreditCosts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      clientId
      endDate
      numberOfCredits
      price
      startDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCreditUsageCosts = /* GraphQL */ `query SyncCreditUsageCosts($filter: ModelCreditUsageCostFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCreditUsageCosts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      endDate
      numberOfCreditsPerOperation
      startDate
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCustomFields = /* GraphQL */ `query SyncCustomFields($filter: ModelCustomFieldFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCustomFields(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      fieldName
      fieldType
      foreignKey
      foreignTableName
      labels {
        language
        label
        __typename
      }
      customFieldProperties {
        isRequired
        isDefault
        defaultValue
        __typename
      }
      order
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncCustomSubscriptions = /* GraphQL */ `query SyncCustomSubscriptions($filter: ModelCustomSubscriptionFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncCustomSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      name
      value
      userId
      _ttl
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncDocumentCategories = /* GraphQL */ `query SyncDocumentCategories($filter: ModelDocumentCategoryFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncDocumentCategories(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncDocumentExtractions = /* GraphQL */ `query SyncDocumentExtractions($filter: ModelDocumentExtractionFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncDocumentExtractions(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      corrected
      createdBy
      evidence {
        bbox
        field
        method
        page
        quote
        rawConfidence
        __typename
      }
      flags
      raw
      reasons
      score
      sectionId
      version
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncDocumentNumbers = /* GraphQL */ `query SyncDocumentNumbers($filter: ModelDocumentNumberFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncDocumentNumbers(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      format
      lastUpdate
      incrementNumber
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncEntityAliases = /* GraphQL */ `query SyncEntityAliases($filter: ModelEntityAliasFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncEntityAliases(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      confirmations
      confirmedBy
      key
      kind
      lastSeenAt
      lookupKey
      printedValue
      senderKeyType
      source
      targetId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncEntityRelations = /* GraphQL */ `query SyncEntityRelations($filter: ModelEntityRelationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncEntityRelations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      sourceId
      sourceTableName
      foreignId
      foreignTableName
      linkDescription
      linkProperties {
        __typename
      }
      clientId
      readers
      readId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncFeeArrearses = /* GraphQL */ `query SyncFeeArrearses($filter: ModelFeeArrearsFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncFeeArrearses(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      accumulatedFrom {
        accumulatedAt
        amount
        paymentOrderId
        __typename
      }
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      openedAt
      originalAmount
      originPaymentOrderId
      originPaymentOrder {
        id
        amount
        anomalies
        anomalyAcknowledgedAt
        anomalyAcknowledgedBy
        anomalyPreviousIban
        anomalyReferenceAmount
        approvedAt
        approvedBy
        bankAccountId
        buildingId
        cancelledAt
        cancelledBy
        cancelReasonCode
        channel
        confirmationDeadlineDate
        counterpartAccountNumber
        counterpartContactId
        counterpartAccountUpdatedAt
        counterpartAccountUpdatedBy
        counterpartName
        counterpartRemittanceInformation
        createdBy
        dueDate
        executedDate
        executedAt
        executedBy
        executedTransactionId
        feeArrearsId
        fixedAt
        fixedBy
        invoiceId
        issuedAt
        issuedBy
        ownerContactId
        paymentBatchId
        periodFrom
        reconciledAt
        recurringPaymentTemplateId
        reference
        reissuedFromOrderId
        reissuedOrderId
        rejectedAt
        rejectedBy
        rejectedField
        rejectedReason
        requestedAmount
        reroutedAt
        reroutedBy
        reroutedFromBankAccountId
        status
        submittedAt
        submittedBy
        suggestionDeclinedReason
        suggestionResolved
        tenantRechargeableRatio
        type
        unitId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerContactId
      ownerContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      servedBy {
        amount
        paymentOrderId
        servedAt
        __typename
      }
      settledAt
      status
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncFiles = /* GraphQL */ `query SyncFiles($filter: ModelFileFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncFiles(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncFilterGroups = /* GraphQL */ `query SyncFilterGroups($filter: ModelFilterGroupFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncFilterGroups(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      filterGroupDetails {
        filterEntityType
        filterEntityField
        filterEntityValues
        filterEntityNumber
        filterEntityDate
        __typename
      }
      name
      screenName
      type
      userId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncImportRuns = /* GraphQL */ `query SyncImportRuns($filter: ModelImportRunFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncImportRuns(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      channel
      files
      finishedAt
      handled
      needsYou
      reviewEverything
      sections
      setAside
      startedAt
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncIntegrations = /* GraphQL */ `query SyncIntegrations($filter: ModelIntegrationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncIntegrations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      configurations {
        name
        value
        __typename
      }
      error
      lastRun
      name
      status
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncInternalComments = /* GraphQL */ `query SyncInternalComments($filter: ModelInternalCommentFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncInternalComments(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      authorId
      content
      entityId
      entityType
      kind
      mentionedUserIds
      userIdsReactions {
        reactionType
        userId
        __typename
      }
      replyToId
      attachmentFileIds
      systemMessage
      systemMessageParameters
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncInvoices = /* GraphQL */ `query SyncInvoices($filter: ModelInvoiceFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncInvoices(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncInvoiceSettings = /* GraphQL */ `query SyncInvoiceSettings($filter: ModelInvoiceSettingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncInvoiceSettings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      creditNoteFormat
      creditNoteLastUpdate
      creditNoteIncrementNumber
      invoiceFormat
      invoiceLastUpdate
      invoiceIncrementNumber
      paymentRequestFormat
      paymentRequestLastUpdate
      paymentRequestIncrementNumber
      receiptFormat
      receiptLastUpdate
      receiptIncrementNumber
      variousOperationFormat
      variousOperationLastUpdate
      variousOperationIncrementNumber
      customInvoicingConfiguration
      defaultVatRateId
      fiscalYearStart
      allPurposeInvoiceIssuer
      paymentBankAccountId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLearningEvents = /* GraphQL */ `query SyncLearningEvents($filter: ModelLearningEventFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLearningEvents(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      at
      field
      from
      kind
      layoutId
      senderId
      to
      userId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLeaseActionHistories = /* GraphQL */ `query SyncLeaseActionHistories($filter: ModelLeaseActionHistoryFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLeaseActionHistories(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      action
      comment
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      historyDetails {
        unitId
        newEndDate
        newSignatureDate
        newStartDate
        previousEndDate
        previousSignatureDate
        previousStartDate
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      communicationChannel
      communicationSendDate
      communicationByPlatform
      endReason
      endReasonOwnUseRelation
      endReasonOwnUseName
      initiator
      totalAmount
      totalAmountLabel
      automatic
      hasLeaseTypeChanged
      jiraId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLeaseAdditionalClauses = /* GraphQL */ `query SyncLeaseAdditionalClauses($filter: ModelLeaseAdditionalClauseFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLeaseAdditionalClauses(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      title
      body
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLeaseContacts = /* GraphQL */ `query SyncLeaseContacts($filter: ModelLeaseContactFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLeaseContacts(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      leaseId
      contactId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactRole
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLeasePriceHistories = /* GraphQL */ `query SyncLeasePriceHistories($filter: ModelLeasePriceHistoryFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLeasePriceHistories(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLeases = /* GraphQL */ `query SyncLeases($filter: ModelLeaseFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLeases(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncLeaseVariousOperations = /* GraphQL */ `query SyncLeaseVariousOperations($filter: ModelLeaseVariousOperationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncLeaseVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncMortgages = /* GraphQL */ `query SyncMortgages($filter: ModelMortgageFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncMortgages(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      lender
      durationInYears
      rateType
      interestRate
      aprRate
      startDate
      amount
      monthlyPayment
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncNotifications = /* GraphQL */ `query SyncNotifications($filter: ModelNotificationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncNotifications(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      createdBy
      type
      message
      popupDate
      expirationDate
      status
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicId
      technic {
        id
        type
        technicLibraryId
        technicName
        lastControlDate
        status
        contractNumber
        communicationSettingsProfileId
        utilityType
        utilityEanCode
        utilityMeterNumber
        utilityDistributorId
        buildingId
        unitId
        leaseId
        contactId
        originalTechnicId
        replacedTechnicId
        certificateIds
        readers
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ticketId
      ticket {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncPaymentBatchs = /* GraphQL */ `query SyncPaymentBatchs($filter: ModelPaymentBatchFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncPaymentBatchs(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncPaymentOrders = /* GraphQL */ `query SyncPaymentOrders($filter: ModelPaymentOrderFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncPaymentOrders(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncPostings = /* GraphQL */ `query SyncPostings($filter: ModelPostingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncPostings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      class
      customLabel
      customValues {
        name
        value
        __typename
      }
      topClass
      type
      totalAmount
      periodFrom
      periodTo
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      chargeId
      charge {
        id
        status
        invoiceDate
        paymentDueDate
        archivedDate
        periodFrom
        periodTo
        totalAmount
        payableAmount
        source
        draftFromOcr
        accountingDocumentId
        paid
        remittanceInformation
        note
        creatorEmail
        createdById
        contractorId
        recipientId
        documentId
        sectionId
        readId
        clientId
        openChargeClientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      transactionId
      transaction {
        id
        status
        snoozedUntil
        sequence
        statementDate
        operationDate
        remittanceInformationType
        remittanceInformation
        remittanceInformationRaw
        additionalInformation
        structuredCommunication
        bankTransactionCode
        proprietaryBankTransactionCode
        endToEndId
        mandateId
        creditorId
        purposeCode
        internalReference
        comment
        exclusionReason
        exclusionComment
        excludedAt
        excludedBy
        amount
        bankAccountId
        counterpartName
        counterpartDisplayName
        counterpartAccountNumber
        origin
        sourceChannel
        nativeTransactionId
        fingerprint
        linkedSourceChannels
        proposedLeaseId
        proposedUnitId
        proposedContractorId
        proposedOwnerId
        proposedMatch
        proposedAllocation
        classification
        classificationConfidence
        classificationReason
        recurrence
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      accountLabelId
      accountLabel {
        id
        bankAccountId
        contactId
        class
        customUsage
        disabled
        hoaFundId
        ownerId
        topClass
        vatNonDeductiblePercentage
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationId
      leaseVariousOperation {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      amountVatExcluded
      vatAmount
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      vatRateId
      vatRateValue
      foreignId
      foreignType
      invoicePostingId
      reconciledAt
      decisionId
      status
      chargeOwnerRepartition
      chargeRepartitionMetric
      chargeRepartitionValue
      chargeSplitNumber
      chargeType
      tenantShare {
        basis
        mode
        percentage
        __typename
      }
      provisional
      flaggedAt
      carriedForward
      tenantLandings {
        amount
        amountVatExcluded
        days
        leaseId
        periodFrom
        periodTo
        statementId
        vatAmount
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncReconciliationDecisions = /* GraphQL */ `query SyncReconciliationDecisions($filter: ModelReconciliationDecisionFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncReconciliationDecisions(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      decisionId
      transactionId
      relatedTransactionIds
      kind
      status
      source
      trigger
      actorId
      outcome
      score
      reasonCodes
      flowType
      amount
      links {
        amount
        linkId
        linkType
        __typename
      }
      allocations {
        invoiceId
        postingId
        amount
        awaitingPosting
        __typename
      }
      exclusionReason
      comment
      snoozedUntil
      reversesDecisionId
      appliesDecisionId
      decidedAt
      backfilled
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncReconciliationSettings = /* GraphQL */ `query SyncReconciliationSettings($filter: ModelReconciliationSettingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncReconciliationSettings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      type
      allocationMode
      leaseId
      ownerId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncRecurringPaymentTemplates = /* GraphQL */ `query SyncRecurringPaymentTemplates($filter: ModelRecurringPaymentTemplateFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncRecurringPaymentTemplates(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amountVersions {
        createdAt
        createdBy
        effectiveFrom
        note
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      beneficiaryBankAccountId
      beneficiaryBankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      beneficiaryContactId
      beneficiaryContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdBy
      endDate
      endedAt
      endedBy
      firstPeriodFrom
      funds {
        accountLabelId
        fundId
        remittanceInformation
        __typename
      }
      generationDay
      lastGeneratedPeriodFrom
      name
      periodicity
      remittanceInformation
      splitTransfers
      status
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncReleaseNotes = /* GraphQL */ `query SyncReleaseNotes($filter: ModelReleaseNoteFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncReleaseNotes(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      status
      publishedAt
      visibleToOwners
      contents {
        language
        title
        body
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncRepartitionKeys = /* GraphQL */ `query SyncRepartitionKeys($filter: ModelRepartitionKeyFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncRepartitionKeys(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      name
      type
      accountLabelId
      accountLabel {
        id
        bankAccountId
        contactId
        class
        customUsage
        disabled
        hoaFundId
        ownerId
        topClass
        vatNonDeductiblePercentage
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitRepartition {
        unitId
        value
        __typename
      }
      ownerRepartition
      tenantRepartition
      repartitionMetric
      technics
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncRepaymentStatements = /* GraphQL */ `query SyncRepaymentStatements($filter: ModelRepaymentStatementFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncRepaymentStatements(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      accountOwnership
      delaysCleared
      expectedRent
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      rentsCollected
      repaymentStatementDetails {
        class
        customLabel
        invoiceId
        invoicePostingId
        originalTotalAmount
        periodFrom
        periodTo
        totalAmount
        transactionId
        type
        __typename
      }
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      totalReceivedInJointAccount
      totalExpectedInOwnerAccount
      unpaidRents
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncScheduleRules = /* GraphQL */ `query SyncScheduleRules($filter: ModelScheduleRuleFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncScheduleRules(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      conditions {
        comparisonMode
        operator
        values
        valueKind
        __typename
      }
      conditionsOperator
      foreignKey
      foreignTableName
      name {
        language
        label
        __typename
      }
      order
      outcome {
        type
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncSenderRules = /* GraphQL */ `query SyncSenderRules($filter: ModelSenderRuleFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncSenderRules(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      senderId
      sender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      kind
      scope {
        accountClass
        identifierKind
        identifierValue
        labelKey
        ownerId
        __typename
      }
      value {
        accountLabelId
        encodesInvoiceNumber
        paymentOnReceipt
        paymentTermDays
        privateExpense
        recoverabilityMode
        recoverabilityPercentage
        reminderFees
        roundingPrecision
        vatRateValues
        __typename
      }
      source
      confirmations
      updatedBy
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncSendingSources = /* GraphQL */ `query SyncSendingSources($filter: ModelSendingSourceFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncSendingSources(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dnsRecords {
        name
        type
        value
        __typename
      }
      emailAddress
      issuesEmail
      chargesEmail
      errorMessage
      name
      lastReminderDate
      status
      statusLastVerification
      verifiedType
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncSettings = /* GraphQL */ `query SyncSettings($filter: ModelSettingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncSettings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      name
      value
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncSignatureDocuments = /* GraphQL */ `query SyncSignatureDocuments($filter: ModelSignatureDocumentFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncSignatureDocuments(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncStatements = /* GraphQL */ `query SyncStatements($filter: ModelStatementFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncStatements(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncStatementSettings = /* GraphQL */ `query SyncStatementSettings($filter: ModelStatementSettingFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncStatementSettings(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      type
      custom
      disabled
      monthFrequency
      startMonth
      generationDay
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncSubscriptionUsageHistories = /* GraphQL */ `query SyncSubscriptionUsageHistories($filter: ModelSubscriptionUsageHistoryFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncSubscriptionUsageHistories(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTags = /* GraphQL */ `query SyncTags($filter: ModelTagFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTags(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      color
      foreignTableName
      labels {
        language
        label
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTechnicLibraries = /* GraphQL */ `query SyncTechnicLibraries($filter: ModelTechnicLibraryFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTechnicLibraries(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTechnics = /* GraphQL */ `query SyncTechnics($filter: ModelTechnicFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTechnics(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTemplates = /* GraphQL */ `query SyncTemplates($filter: ModelTemplateFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTemplates(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      language
      name
      subject
      subjectRawFormat
      body
      bodyRawFormat
      type
      subType
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTickets = /* GraphQL */ `query SyncTickets($filter: ModelTicketFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTickets(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTransactionRules = /* GraphQL */ `query SyncTransactionRules($filter: ModelTransactionRuleFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTransactionRules(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      isFullRemittance
      remittanceInformation
      counterpartName
      counterpartAccountNumber
      usedFields
      exclude
      exclusionReason
      exclusionComment
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncTransactions = /* GraphQL */ `query SyncTransactions($filter: ModelTransactionFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncTransactions(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncUnitEvents = /* GraphQL */ `query SyncUnitEvents($filter: ModelUnitEventFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncUnitEvents(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      unitId
      type
      startDate
      endDate
      totalCost
      note
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncUnitInventories = /* GraphQL */ `query SyncUnitInventories($filter: ModelUnitInventoryFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncUnitInventories(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      privateBatthRoom
      deletedAt
      kitchenEquipment
      roomName
      roomType
      surface
      showSurface
      unitId
      inside
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncUnitLeases = /* GraphQL */ `query SyncUnitLeases($filter: ModelUnitLeaseFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncUnitLeases(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      allowChargeAdjustment
      authorizeProfessionalActivity
      chargesIndexation
      endDate
      furnishedRental
      furnishedRentalInsuranceByTenant
      furnishedRentalRentalPricePercentage
      initialRentalPrice
      indexation
      advancedIndexation
      indexType
      baseYear
      baseIndexType
      baseIndexDate
      nextIndexationMonth
      nextIndexation
      leaseId
      mainUnit
      rentalPrice
      signatureDate
      startDate
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncUnitOwners = /* GraphQL */ `query SyncUnitOwners($filter: ModelUnitOwnerFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncUnitOwners(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      disabled
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ownerId
      periodFrom
      periodTo
      stake
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncUnits = /* GraphQL */ `query SyncUnits($filter: ModelUnitFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncUnits(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncValuations = /* GraphQL */ `query SyncValuations($filter: ModelValuationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncValuations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      sourceType
      valorization
      date
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncVariousOperations = /* GraphQL */ `query SyncVariousOperations($filter: ModelVariousOperationFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncVariousOperations(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      amount
      labels {
        language
        label
        __typename
      }
      numberOfMonths
      operationType
      paymentFrequency
      type
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const syncVatRates = /* GraphQL */ `query SyncVatRates($filter: ModelVatRateFilterInput, $limit: Int, $nextToken: String, $lastSync: AWSTimestamp) {
  syncVatRates(filter: $filter, limit: $limit, nextToken: $nextToken, lastSync: $lastSync) {
    items {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
`;

export const teamManagement = /* GraphQL */ `query TeamManagement {
  teamManagement {
    teams {
      clientId
      id
      name
      parentId
      __typename
    }
    userRoles {
      clientId
      id
      isDefault
      name
      userRights {
        access
        section
        __typename
      }
      __typename
    }
    userTeams {
      clientId
      dynamoUserId
      id
      teamId
      userId
      __typename
    }
    __typename
  }
}
`;

export const treasuryAccounts = /* GraphQL */ `query TreasuryAccounts($scope: ScopeInput!) {
  treasuryAccounts(scope: $scope) {
    balance
    id
    initiationChannels
    isAgencyAccount
    label
    number
    plannedCount
    plannedTotal
    projectedBalance
    reconciliationCovered
    retainedBalanceThreshold
    type
    __typename
  }
}
`;
